const deliveryRouter = [
  {
    path: '/delivery',
    name: 'delivery',
    component: () => import('@/views/wxapp/project-delivery/'),
    meta: {
      title: '工地在线'
    },
    children: [
      // =====================jinfeng=========================
      {
        path: 'login',
        name: 'delivery-login',
        component: () => import('@/views/wxapp/project-delivery/login'),
        meta: {
          title: '登录'
        }
      },
      {
        path: 'home',
        name: 'delivery-home',
        component: () => import('@/views/wxapp/project-delivery/home'),
        meta: {
          title: '交付板块'
        }
      },
      {
        path: 'science',
        name: 'delivery-material-science',
        component: () => import('@/views/wxapp/project-delivery/materialScience'),
        meta: {
          title: '交付板块'
        }
      },
      {
        path: 'progress',
        name: 'delivery-material-progress',
        component: () => import('@/views/wxapp/project-delivery/materialScience/materialprogress'),
        meta: {
          title: '用户下单情况'
        }
      },
      {
        path: 'details',
        name: 'progress-details',
        component: () => import('@/views/wxapp/project-delivery/materialScience/progressDetails'),
        meta: {
          title: '材料进度详情'
        }
      },
      // Purchase order
      {
        path: 'purchaseOrder',
        name: 'purchase-order',
        component: () => import('@/views/wxapp/project-delivery/materialScience/purchaseOrder'),
        meta: {
          title: '采购单进度'
        }
      },
      {
        path: 'purchaseOrderDetails',
        name: 'purchase-order-details',
        component: () => import('@/views/wxapp/project-delivery/materialScience/purchaseOrderDetails'),
        meta: {
          title: '采购单详情'
        }
      },
      {
        path: 'InspectionNote',
        name: 'inspection-note',
        component: () => import('@/views/wxapp/project-delivery/materialScience/InspectionNote'),
        meta: {
          title: '验货单'
        }
      },
      {
        path: 'logisticsOrder',
        name: 'logistics-order',
        component: () => import('@/views/wxapp/project-delivery/materialScience/logisticsOrder'),
        meta: {
          title: '物流单'
        }
      },
      {
        path: 'siteDeliveryList',
        name: 'site-delivery-list',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery'),
        meta: {
          title: '交底列表'
        }
      },
      {
        path: 'siteDeliveryDetail/:orderId',
        name: 'site-delivery-detail',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery/detail'),
        meta: {
          title: '工地详情'
        },
        props: true
      },
      {
        path: 'timeline/:orderId',
        name: 'site-delivery-timeline-add',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery/timeline'),
        meta: {
          title: '项目排期表'
        },
        props: true
      },
      {
        path: 'timelineView/:orderId',
        name: 'site-delivery-timeline-view',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery/timeline/view'),
        meta: {
          title: '项目排期表'
        },
        props: true
      },
      {
        path: 'siteDeliveryProcessStart/:orderId',
        name: 'site-delivery-process_start',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery/addProcessStart'),
        meta: {
          title: '开工仪式'
        },
        props: true
      },
      // {
      //   path: 'siteDeliveryProcessStart/:orderId',
      //   name: 'site-delivery-process_start',
      //   component: () => import('@/views/wxapp/project-delivery/siteDelivery/addProcessStart'),
      //   meta: {
      //     title: '开工仪式'
      //   },
      //   props: true
      // },
      {
        path: 'processStarted/:orderId',
        name: 'site-delivery-process_started',
        component: () => import('@/views/wxapp/project-delivery/siteDelivery/processStarted'),
        meta: {
          title: '开工仪式'
        },
        props: true
      },
      {
        path: 'projectStart/:orderId',
        name: 'site-delivery-project_start',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/projectStart'),
        meta: {
          title: '正式开工'
        },
        props: true
      },
      {
        path: 'projectConstructionList',
        name: 'project-construction-list',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction'),
        meta: {
          title: '工地施工'
        }
      },
      {
        path: 'projectConstructionDetail/:orderId',
        name: 'project-construction-detail',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/detail'),
        meta: {
          title: '工地施工详情'
        },
        props: true
      },
      {
        path: 'addConstructionBroadcast/:orderId',
        name: 'add-construction-broadcast',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addConstructionBroadcast'),
        meta: {
          title: '今日播报'
        },
        props: true
      },
      {
        path: 'addOldNodeBroadcast/:orderId/:processInfo',
        name: 'add-old_node-broadcast',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addOldNodeBroadcast'),
        meta: {
          title: '今日播报'
        },
        props: true
      },
      {
        path: 'addMaterialBroadcast/:orderId/:processId/:processName',
        name: 'add-material-broadcast',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addMaterialBroadcast'),
        meta: {
          title: '材料到场'
        },
        props: true
      },
      {
        path: 'addShutdownBroadcast/:orderId/:processId/:messageInfo',
        name: 'add-shutdown-broadcast',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addShutdownBroadcast'),
        meta: {
          title: '异常停工'
        },
        props: true
      },
      {
        path: 'addPeriodChangeBroadcast/:orderId/:processId/:processName',
        name: 'add-period_change-broadcast',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addPeriodChangeBroadcast'),
        meta: {
          title: '工期变更'
        },
        props: true
      },
      {
        path: 'addBroadcastSuccess',
        name: 'add-broadcast-success',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/addBroadcastSuccess'),
        meta: {
          title: '创建成功'
        },
        props: true
      },
      {
        path: 'turn-examine-success',
        name: 'TurnExamineSuccess',
        component: () => import('@/views/wxapp/project-delivery/projectConstruction/turnExamineSuccess'),
        meta: {
          title: '创建审核成功'
        },
        props: true
      },
      {
        path: 'afterSaleList',
        name: 'after-sale-list',
        component: () => import('@/views/wxapp/project-delivery/afterSale'),
        meta: {
          title: '售后工地'
        },
        props: true
      },
      {
        path: 'afterSaleDetail',
        name: 'after-sale-detail',
        component: () => import('@/views/wxapp/project-delivery/afterSale/detail'),
        meta: {
          title: '售后工地'
        },
        props: true
      },
      // ======================shiqiong========================
      {
        path: 'problem-list',
        name: 'problem-list',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/problem-list'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'problem-assignment',
        name: 'problem-assignment',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/problem-assignment'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'problem-handle',
        name: 'problem-handle',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/problem-handle'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'handle-detail',
        name: 'handle-detail',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/handle-detail'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'assignment-detail',
        name: 'assignment-detail',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/assignment-detail'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'problem-index',
        name: 'problem-index',
        component: () => import('@/views/wxapp/project-delivery/customerComplaint/problem-index'),
        meta: {
          title: '客诉处理'
        }
      },
      // =======================yuehui=======================
      {
        path: 'completion-ceremony-info',
        name: 'completion-ceremony-info',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/completion-ceremony-info'),
        meta: {
          title: '竣工仪式'
        }
      },
      {
        path: 'completion-ceremony',
        name: 'completion-ceremony',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/completion-ceremony'),
        meta: {
          title: '新建竣工仪式'
        }
      },
      {
        path: 'create-fix',
        name: 'create-fix',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/create-fix'),
        meta: {
          title: '新建整改'
        }
      },
      {
        path: 'node-patrol',
        name: 'node-patrol',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/node-patrol'),
        meta: {
          title: '创建节点播报'
        }
      },
      {
        path: 'daily-patrol',
        name: 'daily-patrol',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/daily-patrol'),
        meta: {
          title: '创建日常播报'
        }
      },
      {
        path: 'patrol-list',
        name: 'patrol-list',
        component: () => import('@/views/wxapp/project-delivery/patrol'),
        meta: {
          title: '工地巡检'
        }
      },
      {
        path: 'patrol-detail',
        name: 'patrol-detail',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail'),
        meta: {
          title: '工地巡检详情'
        }
      },
      {
        path: 'waiting-initiated-delivery',
        name: 'waiting-initiated-delivery',
        component: () => import('@/views/wxapp/designer-manager/list/waitingInitiatedDelivery'),
        meta: {
          title: '待交底'
        }
      },
      {
        path: 'confessionInvitationDelivery',
        name: 'confessionInvitationDelivery',
        component: () => import('@/views/wxapp/designer-manager/confessionInvitationDelivery'),
        meta: {
          title: '交底邀约'
        }
      },
      {
        path: 'complaint-list',
        name: 'ComplaintList',
        component: () => import('@/views/wxapp/customer-complaint/complaint-list'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'response-list',
        name: 'ResponseList',
        component: () => import('@/views/wxapp/customer-complaint/response-list'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'complaint-details',
        name: 'ComplaintDetails',
        component: () => import('@/views/wxapp/customer-complaint/complaint-details'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'response-details',
        name: 'ResponseDetails',
        component: () => import('@/views/wxapp/customer-complaint/response-details'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'examine-info',
        name: 'ExamineInfo',
        component: () => import('@/views/wxapp/project-delivery/patrol/detail/examineInfo'),
        meta: {
          title: '工程审核'
        }
      }

    ]
  }
]
export default deliveryRouter
